import { selectSelectedWatchlistId } from '@unistocks/features/watchlists/store/watchlist.slice';
import { useWatchlistsGetListQuery } from '@unistocks/proxy/axios-client/WatchlistsQuery';
import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { Href } from 'expo-router';

export const useDefaultWatchlistRoute = (): Href => {
  const { data: watchlists } = useWatchlistsGetListQuery();
  const selectedWatchlistId =
    useAppSelector(selectSelectedWatchlistId) ?? watchlists?.items[0]?.id ?? '';

  const watchlistHref: Href = selectedWatchlistId
    ? {
        pathname: '/(tabs)/watchlists/[id]',
        params: { id: selectedWatchlistId }
      }
    : '/(tabs)/watchlists/create';

  return watchlistHref;
};
